export {
  DropzoneComponent, DropzoneDirective,
  DropzoneConfig, DropzoneConfigInterface, DropzoneThumbnail,
  DropzoneEvents,
  provideDefaultConfig, provideForRootGuard,
  DROPZONE_CONFIG, DROPZONE_GUARD,
  DropzoneModule
} from './lib/index';
